// extracted by mini-css-extract-plugin
module.exports = {"wishlist":"styles_wishlist__I5JhU","wishlist-wrapper":"styles_wishlist-wrapper__3-5nz","wishlist__card":"styles_wishlist__card__1XhLz"};